export default {
    title: 'ការជូនដំណឹង',
    notification: 'ការជូនដំណឹង',
    see_all: 'មើល​ទាំងអស់',
    no_notification: 'បញ្ជីទទេ',
    show_unread: 'បង្ហាញតែសារមិនទាន់អាន',
    alert_retention_period:
        'ការជូនដំណឹងនឹងត្រូវបានលុបបន្ទាប់ពី {retentionPeriod}',
};
